import { useTranslation } from 'react-i18next'

export default ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const label = t('Flag of United States.', { context: 'alt text for image of the US flag' })

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={label}
      className={className}
    >
      <rect y="3.42856" width="24" height="17.1429" rx="2" fill="white" />
      <mask
        id="mask0_1_809"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="24"
        height="18"
      >
        <rect y="3.42856" width="24" height="17.1429" rx="2" fill="white" />
      </mask>
      <g mask="url(#mask0_1_809)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 3.42856H0V4.57142H24V3.42856ZM24 5.71426H0V6.85712H24V5.71426ZM0 8H24V9.14286H0V8ZM24 10.2857H0V11.4286H24V10.2857ZM0 12.5714H24V13.7143H0V12.5714ZM24 14.8571H0V16H24V14.8571ZM0 17.1428H24V18.2857H0V17.1428ZM24 19.4285H0V20.5714H24V19.4285Z"
          fill="#D02F44"
        />
        <rect y="3.42856" width="10.2857" height="8" fill="#46467F" />
        <g filter="url(#filter0_d_1_809)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.28572 5.14287C2.28572 5.45846 2.02989 5.7143 1.7143 5.7143C1.39871 5.7143 1.14287 5.45846 1.14287 5.14287C1.14287 4.82728 1.39871 4.57144 1.7143 4.57144C2.02989 4.57144 2.28572 4.82728 2.28572 5.14287ZM4.57143 5.14287C4.57143 5.45846 4.31559 5.7143 4 5.7143C3.68441 5.7143 3.42857 5.45846 3.42857 5.14287C3.42857 4.82728 3.68441 4.57144 4 4.57144C4.31559 4.57144 4.57143 4.82728 4.57143 5.14287ZM6.28574 5.7143C6.60133 5.7143 6.85717 5.45846 6.85717 5.14287C6.85717 4.82728 6.60133 4.57144 6.28574 4.57144C5.97015 4.57144 5.71431 4.82728 5.71431 5.14287C5.71431 5.45846 5.97015 5.7143 6.28574 5.7143ZM9.14287 5.14287C9.14287 5.45846 8.88703 5.7143 8.57144 5.7143C8.25585 5.7143 8.00001 5.45846 8.00001 5.14287C8.00001 4.82728 8.25585 4.57144 8.57144 4.57144C8.88703 4.57144 9.14287 4.82728 9.14287 5.14287ZM2.85717 6.85717C3.17276 6.85717 3.42859 6.60133 3.42859 6.28574C3.42859 5.97015 3.17276 5.71431 2.85717 5.71431C2.54157 5.71431 2.28574 5.97015 2.28574 6.28574C2.28574 6.60133 2.54157 6.85717 2.85717 6.85717ZM5.7143 6.28574C5.7143 6.60133 5.45846 6.85717 5.14287 6.85717C4.82728 6.85717 4.57144 6.60133 4.57144 6.28574C4.57144 5.97015 4.82728 5.71431 5.14287 5.71431C5.45846 5.71431 5.7143 5.97015 5.7143 6.28574ZM7.42857 6.85717C7.74416 6.85717 8 6.60133 8 6.28574C8 5.97015 7.74416 5.71431 7.42857 5.71431C7.11298 5.71431 6.85714 5.97015 6.85714 6.28574C6.85714 6.60133 7.11298 6.85717 7.42857 6.85717ZM9.14287 7.42857C9.14287 7.74416 8.88703 8 8.57144 8C8.25585 8 8.00001 7.74416 8.00001 7.42857C8.00001 7.11298 8.25585 6.85714 8.57144 6.85714C8.88703 6.85714 9.14287 7.11298 9.14287 7.42857ZM6.28574 8C6.60133 8 6.85717 7.74416 6.85717 7.42857C6.85717 7.11298 6.60133 6.85714 6.28574 6.85714C5.97015 6.85714 5.71431 7.11298 5.71431 7.42857C5.71431 7.74416 5.97015 8 6.28574 8ZM4.57143 7.42857C4.57143 7.74416 4.31559 8 4 8C3.68441 8 3.42857 7.74416 3.42857 7.42857C3.42857 7.11298 3.68441 6.85714 4 6.85714C4.31559 6.85714 4.57143 7.11298 4.57143 7.42857ZM1.7143 8C2.02989 8 2.28572 7.74416 2.28572 7.42857C2.28572 7.11298 2.02989 6.85714 1.7143 6.85714C1.39871 6.85714 1.14287 7.11298 1.14287 7.42857C1.14287 7.74416 1.39871 8 1.7143 8ZM3.42859 8.57144C3.42859 8.88703 3.17276 9.14287 2.85717 9.14287C2.54157 9.14287 2.28574 8.88703 2.28574 8.57144C2.28574 8.25585 2.54157 8.00001 2.85717 8.00001C3.17276 8.00001 3.42859 8.25585 3.42859 8.57144ZM5.14287 9.14287C5.45846 9.14287 5.7143 8.88703 5.7143 8.57144C5.7143 8.25585 5.45846 8.00001 5.14287 8.00001C4.82728 8.00001 4.57144 8.25585 4.57144 8.57144C4.57144 8.88703 4.82728 9.14287 5.14287 9.14287ZM8 8.57144C8 8.88703 7.74416 9.14287 7.42857 9.14287C7.11298 9.14287 6.85714 8.88703 6.85714 8.57144C6.85714 8.25585 7.11298 8.00001 7.42857 8.00001C7.74416 8.00001 8 8.25585 8 8.57144ZM8.57144 10.2857C8.88703 10.2857 9.14287 10.0299 9.14287 9.71431C9.14287 9.39872 8.88703 9.14288 8.57144 9.14288C8.25585 9.14288 8.00001 9.39872 8.00001 9.71431C8.00001 10.0299 8.25585 10.2857 8.57144 10.2857ZM6.85717 9.71431C6.85717 10.0299 6.60133 10.2857 6.28574 10.2857C5.97015 10.2857 5.71431 10.0299 5.71431 9.71431C5.71431 9.39872 5.97015 9.14288 6.28574 9.14288C6.60133 9.14288 6.85717 9.39872 6.85717 9.71431ZM4 10.2857C4.31559 10.2857 4.57143 10.0299 4.57143 9.71431C4.57143 9.39872 4.31559 9.14288 4 9.14288C3.68441 9.14288 3.42857 9.39872 3.42857 9.71431C3.42857 10.0299 3.68441 10.2857 4 10.2857ZM2.28572 9.71431C2.28572 10.0299 2.02989 10.2857 1.7143 10.2857C1.39871 10.2857 1.14287 10.0299 1.14287 9.71431C1.14287 9.39872 1.39871 9.14288 1.7143 9.14288C2.02989 9.14288 2.28572 9.39872 2.28572 9.71431Z"
            fill="url(#paint0_linear_1_809)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_1_809"
          x="1.14287"
          y="4.57144"
          width="8"
          height="6.71429"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_809" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_809" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_1_809"
          x1="1.14287"
          y1="4.57144"
          x2="1.14287"
          y2="10.2857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F0F0F0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
